import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7001Model } from '../kymw7001.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { CodeListInfo } from '../vo/code_list_info.model';

// レスポンス構造
type GetMediumListByOrderResponse = {
  MediumType: string;
  MediumName: string;
}[];

/**
 * 媒体リスト取得サービス
 * @export GetMediumListByOrderService
 * @class GetMediumListByOrderService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetMediumListByOrderService extends PlessJsonResponderSub<GetMediumListByOrderResponse> {
  model: KYMW7001Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetMediumListByOrderService
   */
  private getBody(): PlessRequest {
    const searchObj = {
      GetMediumList: {
        condition: {
          OrderCode: this.model.orderCode,
        },
      }
    }

    return new PlessRequest({ search: searchObj });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetMediumListByOrderService
   */
  execute(model: KYMW7001Model, f?: () => void): void {
    this.model = model;
    if (f) this.calbak = f;
    this.send('KYMW70getMediumListByOrder', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetMediumListByOrderService
   */
  success(data: GetMediumListByOrderResponse) {
    const mediumList = [];
    data.forEach(item => {
      const addList = new CodeListInfo(item.MediumType,item.MediumName);
      mediumList.push(addList)
    })
    this.model.MediumList = mediumList;
    if (this.calbak) this.calbak();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
